import { render, staticRenderFns } from "./ContactGroupManager.vue?vue&type=template&id=310cd4a2&scoped=true"
import script from "./ContactGroupManager.vue?vue&type=script&lang=js"
export * from "./ContactGroupManager.vue?vue&type=script&lang=js"
import style0 from "./ContactGroupManager.vue?vue&type=style&index=0&id=310cd4a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310cd4a2",
  null
  
)

export default component.exports